



















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import searchTool from '../other/SearchToolBar.vue'
import _ from 'lodash'
import { multBindPerson } from '../../../interfaces/service/org/enterpriseMang'
import { getAvatarUserData } from '../../../interfaces/service/person/userAuthority'
import { commitSetLoading, commitSetOrgChangeData } from '../../../store/main/mutations'
const returnData: any = { visable: true }
@Component({
  components: { searchTool },
  data() {
    return {
    }
  },
})
export default class NewUserModel extends Vue {
  public personDatas: any = []
  @Prop({ required: true }) public groupOrgID!: any

  // 添加员工
  public userBinds: any = []// 选中的userID用于绑定
  public theWindowH = document.body.clientHeight // 窗口高度
  public addPersonFlag: boolean = false
  public subLoading: boolean = false
  @Watch('$store.state.main.waitloading')
  public resetLoading() {
    this.subLoading = this.$store.state.main.waitloading
  }
  @Watch('$store.state.main.screen.height') public windowHeight() {
    this.theWindowH = document.body.clientHeight
  }
  public transChange(targetKeys, direction, moveKeys) {
    this.userBinds = targetKeys
  }
  public modelCancel() {
    // model取消
    this.addPersonFlag = false
    returnData.visable = false
    this.$emit('modelFun', returnData)
  }
  public async modelSubmit() {
    commitSetLoading(this.$store, true)
    // model提交
    this.addPersonFlag = false
    returnData.visable = false

    await multBindPerson(
      this.$store.state.main.userProfile.user_type,
      this.groupOrgID,
      this.userBinds
    )
    await getAvatarUserData(
      this.$store.state.main.userProfile.user_type,
      this.groupOrgID
    )
    this.$emit('modelFun', returnData)
    commitSetLoading(this.$store, false)
    commitSetOrgChangeData(this.$store, Number(new Date()))
  }
  private async created() {
    const ranterId = sessionStorage.getItem('ranterId')
    await getAvatarUserData(this.$store.state.main.userProfile.user_type, ranterId)
    this.personDatas = this.$store.state.main.userAuthorityShow.userData.map(
        (e) => {
          e.title = e.name
          e.key = e.id.toString()
          return e
        }
      )
    await getAvatarUserData(this.$store.state.main.userProfile.user_type, this.groupOrgID)
    this.userBinds = _.values(
    this.$store.state.main.userAuthorityShow.userData.map((e) => {
      return e.id.toString()
    })
  )
  }
}
